import { render, staticRenderFns } from "./indexOfClaim.vue?vue&type=template&id=1054eb8c&scoped=true"
import script from "./indexOfClaim.vue?vue&type=script&lang=ts"
export * from "./indexOfClaim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054eb8c",
  null
  
)

export default component.exports